import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaSlotRemovalsBulkUploadResponse } from "@/api_framework/api_modals/Rota";
import axios from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => { });

export const useRotaSlotRemovalsBulkUploadAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [loading, setLoading] = useState<boolean>(false);

  const execute = useCallback(
    async (file: File | Blob): Promise<IRotaSlotRemovalsBulkUploadResponse> => {
      setLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const formData = new FormData();
        formData.append("file", file);

        const res = await axios.post<IRotaSlotRemovalsBulkUploadResponse>(
          ROTA_APIS?.ROTA_SLOT_REMOVALS_BULK_UPLOAD?.baseURL ?? "",
          formData,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );

        const parsedResponse = res.data;

        if (parsedResponse?.status === true) {
          toast.success(parsedResponse.message ?? "Bulk upload completed");
          return parsedResponse;
        }

        toast.error(parsedResponse?.message ?? "Bulk upload failed");
        return parsedResponse;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          sendCurl?.(error.config?.["curlCommand"]);
          captureError(error);

          return {
            status: false,
            message: error.response?.data?.message ?? "Failed to upload slot removals",
            data: null,
          };
        }

        const err = error as Error;
        toast.error("Server Error: " + err.message);
        return {
          status: false,
          message: err.message,
          data: null,
        };
      } finally {
        setLoading(false);
      }
    },
    [captureError, configuration, sendCurl],
  );

  return { execute, loading };
};
